/**
 * Defines the common delivery price for **orders with tax**.
 */
export const deliveryCommonPrice = 250;
